/**
 * Service: api
 *
 * Exposes API functionality
 *
 */
angular.module('acme.common.service.api', [
    'acme.common.service.administrationApi',
    'acme.common.service.analyticsApi',
    'acme.common.service.cartApi',
    'acme.common.service.comboApi',
    'acme.common.service.couponsApi',
    'acme.common.service.customFieldsApi',
    'acme.common.service.customerFeesApi',
    'acme.common.service.rateCardsApi',
    'acme.common.service.customerServiceApi',
    'acme.common.service.customersApi',
    'acme.common.service.departmentsApi',
    'acme.common.service.discountsApi',
    'acme.common.service.donationsApi',
    'acme.common.service.emailStatusApi',
    'acme.common.service.entityApi',
    'acme.common.service.entitlementsApi',
    'acme.common.service.eventApi',
    'acme.common.service.featureToggle',
    'acme.common.service.financeApi',
    'acme.common.service.formApi',
    'acme.common.service.glcodesApi',
    'acme.common.service.groupsApi',
    'acme.common.service.historyApi',
    'acme.common.service.inventoryApi',
    'acme.common.service.inventoryB2CApi',
    'acme.common.service.importJobsApi',
    'acme.common.service.importJobExecutionsApi',
    'acme.common.service.importExportsApi',
    'acme.common.service.lockApi',
    'acme.common.service.membershipApi',
    'acme.common.service.navigationApi',
    'acme.common.service.offline',
    'acme.common.service.ordersApi',
    'acme.common.service.organizationsApi',
    'acme.common.service.partnersApi',
    'acme.common.service.passesApi',
    'acme.common.service.permissionsApi',
    'acme.common.service.photosApi',
    'acme.common.service.posApi',
    'acme.common.service.posCloudConfiguration',
    'acme.common.service.priceApi',
    'acme.common.service.programApi',
    'acme.common.service.proxyUserApi',
    'acme.common.service.refundsApi',
    'acme.common.service.reportingApi',
    'acme.common.service.reservation',
    'acme.common.service.resourceApi',
    'acme.common.service.rolesApi',
    'acme.common.service.rulesEngineApi',
    'acme.common.service.settlementsApi',
    'acme.common.service.subscriptionsApi',
    'acme.common.service.systemApi',
    'acme.common.service.tenantApi',
    'acme.common.service.terminalsApi',
    'acme.common.service.themesApi',
    'acme.common.service.ticketsApi',
    'acme.common.service.userApi',
    'acme.common.service.userPreferencesApi',
    'acme.common.service.walkinsApi',
    'acme.common.service.loggerApi',
    'acme.common.service.dedupeApi',
    'acme.common.service.textVariablesApi',
    'acme.common.service.householdApi',
    'acme.common.service.sfdcApi',
  ])
  .service('ApiService', ['$http', 'ProgramApiService', 'UserApiService', 'ResourceApiService', 'TenantApiService',
    'ProxyUserApiService', 'PriceApiService', 'EventApiService', 'PhotosApiService', 'ReportingApiService',
    'FinanceApiService',
    'AnalyticsApiService', 'OrdersApiService', 'EntityApiService', 'EntitlementsApiService', 'DepartmentsApiService', 'ThemesApiService',
    'SettlementsApiService', 'CustomerServiceApiService', 'RefundsApiService', 'PartnersApiService', 'SubscriptionsApiService',
    'WalkinsApiService',
    'DiscountsApiService', 'InventoryApiService', 'InventoryB2CApiService', 'ComboApiService', 'MembershipApiService', 'NavigationApiService',
    'PermissionsApiService', 'GroupsApiService', 'RolesApiService', 'TerminalsApiService', 'HistoryApiService',
    'CouponsApiService', 'CustomFieldsApiService', 'CustomerFeesApiService', 'RateCardsApiService', 'CartApiService', 'GlcodesApiService', 'AdministrationApiService',
    'EmailStatusApiService',
    'PosApiService', 'PosCloudConfigurationService', 'UserPreferencesApiService', 'TicketsApiService',
    'OrganizationsApiService', 'FormApiService', 'SystemApiService', 'RulesEngineApiService', 'PassesApiService',
    'LockApiService', 'DonationsApiService', 'CustomersApiService', 'ReservationService', 'LoggerApiService', 'DedupeApiService', 'TextVariablesApiService', 'HouseholdApiService', 'SfdcApiService',
    function ($http, ProgramApiService, UserApiService, ResourceApiService, TenantApiService, ProxyUserApiService,
      PriceApiService, EventApiService, PhotosApiService, ReportingApiService, FinanceApiService, AnalyticsApiService,
      OrdersApiService, EntityApiService, EntitlementsApiService, DepartmentsApiService, ThemesApiService, SettlementsApiService,
      CustomerServiceApiService, RefundsApiService, PartnersApiService, SubscriptionsApiService, WalkinsApiService, DiscountsApiService,
      InventoryApiService, InventoryB2CApiService, ComboApiService, MembershipApiService, NavigationApiService, PermissionsApiService,
      GroupsApiService, RolesApiService, TerminalsApiService, HistoryApiService, CouponsApiService,
      CustomFieldsApiService, CustomerFeesApiService, RateCardsApiService, CartApiService, GlcodesApiService, AdministrationApiService, EmailStatusApiService,
      PosApiService, PosCloudConfigurationService, UserPreferencesApiService, TicketsApiService,
      OrganizationsApiService, FormApiService, SystemApiService, RulesEngineApiService, PassesApiService,
      LockApiService, DonationsApiService, CustomersApiService, ReservationApiService, LoggerApiService, DedupeApiService, TextVariablesApiService, HouseholdApiService, SfdcApiService) {
      var service = {

        // TODO: Make configurable
        endpoint: '/v1/api',

        init: function () {
          this.administration.init(this.endpoint);
          this.analytics.init(this.endpoint);
          this.cart.init(this.endpoint);
          this.combo.init(this.endpoint);
          this.coupons.init(this.endpoint);
          this.customFields.init(this.endpoint);
          this.customerFees.init(this.endpoint);
          this.rateCards.init(this.endpoint);
          this.customerService.init(this.endpoint);
          this.customers.init(this.endpoint);
          this.departments.init(this.endpoint);
          this.discounts.init(this.endpoint);
          this.donations.init(this.endpoint);
          this.emailStatus.init(this.endpoint);
          this.entity.init(this.endpoint);
          this.entitlements.init(this.endpoint);
          this.event.init(this.endpoint);
          this.finance.init(this.endpoint);
          this.form.init(this.endpoint);
          this.glcodes.init(this.endpoint);
          this.groups.init(this.endpoint);
          this.history.init(this.endpoint);
          this.inventory.init(this.endpoint);
          this.inventoryB2C.init(this.endpoint);
          this.lock.init(this.endpoint);
          this.membership.init(this.endpoint);
          this.navigation.init(this.endpoint);
          this.orders.init(this.endpoint);
          this.organizations.init(this.endpoint);
          this.partners.init(this.endpoint);
          this.passes.init(this.endpoint);
          this.permissions.init(this.endpoint);
          this.photos.init(this.endpoint);
          this.pos.init(this.endpoint);
          this.price.init(this.endpoint);
          this.program.init(this.endpoint);
          this.refunds.init(this.endpoint);
          this.reporting.init(this.endpoint);
          this.resource.init(this.endpoint);
          this.roles.init(this.endpoint);
          this.rulesEngine.init(this.endpoint);
          this.settlements.init(this.endpoint);
          this.subscriptions.init(this.endpoint);
          this.system.init(this.endpoint);
          this.tenant.init(this.endpoint);
          this.terminals.init(this.endpoint);
          this.themes.init(this.endpoint);
          this.tickets.init(this.endpoint);
          this.user.init(this.endpoint);
          this.userPreferences.init(this.endpoint);
          this.userProxy.init(this.endpoint);
          this.walkins.init(this.endpoint);
          this.logger.init(this.endpoint);
          this.dedupe.init(this.endpoint);
          this.textVariables.init(this.endpoint);
          this.household.init(this.endpoint);
          this.sfdc.init(this.endpoint);
        },

        administration: AdministrationApiService,
        analytics: AnalyticsApiService,
        cart: CartApiService,
        combo: ComboApiService,
        coupons: CouponsApiService,
        customFields: CustomFieldsApiService,
        customerFees: CustomerFeesApiService,
        rateCards: RateCardsApiService,
        customerService: CustomerServiceApiService,
        customers: CustomersApiService,
        departments: DepartmentsApiService,
        discounts: DiscountsApiService,
        donations: DonationsApiService,
        emailStatus: EmailStatusApiService,
        entity: EntityApiService,
        entitlements: EntitlementsApiService,
        event: EventApiService,
        finance: FinanceApiService,
        form: FormApiService,
        glcodes: GlcodesApiService,
        groups: GroupsApiService,
        history: HistoryApiService,
        inventory: InventoryApiService,
        inventoryB2C: InventoryB2CApiService,
        lock: LockApiService,
        membership: MembershipApiService,
        navigation: NavigationApiService,
        orders: OrdersApiService,
        organizations: OrganizationsApiService,
        partners: PartnersApiService,
        passes: PassesApiService,
        permissions: PermissionsApiService,
        photos: PhotosApiService,
        pos: PosApiService,
        price: PriceApiService,
        program: ProgramApiService,
        refunds: RefundsApiService,
        reporting: ReportingApiService,
        reservations: ReservationApiService,
        resource: ResourceApiService,
        roles: RolesApiService,
        rulesEngine: RulesEngineApiService,
        settlements: SettlementsApiService,
        subscriptions: SubscriptionsApiService,
        system: SystemApiService,
        tenant: TenantApiService,
        terminals: TerminalsApiService,
        themes: ThemesApiService,
        tickets: TicketsApiService,
        user: UserApiService,
        userPreferences: UserPreferencesApiService,
        userProxy: ProxyUserApiService,
        walkins: WalkinsApiService,
        logger: LoggerApiService,
        dedupe: DedupeApiService,
        textVariables: TextVariablesApiService,
        household: HouseholdApiService,
        sfdc: SfdcApiService
      };

      service.init();

      return service;
    }
  ])
  .config([
    'FeatureToggleServiceProvider',
    'ImportJobsApiServiceProvider',
    'ImportJobExecutionsApiServiceProvider',
    'ImportExportsApiServiceProvider',
    'OfflineServiceProvider',
    'PosCloudConfigurationServiceProvider',
    'ReservationServiceProvider',
    function (
      FeatureToggleServiceProvider,
      ImportJobsApiServiceProvider,
      ImportJobExecutionsApiServiceProvider,
      ImportExportsApiServiceProvider,
      OfflineServiceProvider,
      PosCloudConfigurationServiceProvider,
      ReservationServiceProvider
    ) {
      FeatureToggleServiceProvider.setEndpoint('/service/feature/toggles');
      ImportJobsApiServiceProvider.setEndpoint('/service/import/api/job');
      ImportJobExecutionsApiServiceProvider.setEndpoint('/service/import/api');
      ImportExportsApiServiceProvider.setEndpoint('/service/import/api/export');
      OfflineServiceProvider.setEndpoint('/v2/api/b2c/checkout/pointofsale/offline');
      PosCloudConfigurationServiceProvider.setEndpoint('/v2/api/configuration/pos');
      ReservationServiceProvider.setEndpoint('/v2/api/reservations');
    }
  ]);
